( function( $, document, window ) {
    'use strict';

    $( function() {
    	const $locationsMenuTrigger = $( '.js-locations-menu-trigger' );
        const $locationsMenu = $( '.js-locations-menu-body' );
        const duration = 400; // default
	    const activeClass = 'is-active';

        $locationsMenuTrigger.on( 'click', function() {
        	$locationsMenu.slideToggle( duration, function() {
        		if ( $( this ).hasClass( activeClass ) ) {
        			$( this ).removeClass( activeClass );
		        } else {
        			$( this ).addClass( activeClass );
		        }
	        } );
        } );
    } );
} )( jQuery, document, window );
